import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailCampaignContractSubmittedComponent } from '../../components/email-campaign-contract-submitted/email-campaign-contract-submitted.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  styleUrls: ['../../global-styles.less'],
  templateUrl: './campaign-contract-submitted-template.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailCampaignContractSubmittedComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class CampaignContractSubmittedTemplateTemplateComponent {
  @Input({ required: true })
  public data: WrappedValue<CampaignContractSubmittedTemplateTemplateData>;
}

export type Product = {
  title: string;
};

export type CampaignContractSubmittedTemplateTemplateData = {
  header: string;
  subheader_html: string;
  body: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
  order_summary: string;
  products: Product[];
  primary_cta: {
    href: string;
    label: string;
  };
};

export const CampaignContractSubmittedTemplateTemplateMocks: CampaignContractSubmittedTemplateTemplateData[] =
  [
    {
      header: 'Campaign successfully submitted',
      subheader_html: `Your campaign, <b>[Campaign Name]</b>, has been successfully submitted.`,
      body: "We'll keep you updated on the status of each channel. You can also track these changes anytime through our app.",
      footer: {
        text: 'Need help?',
        href: 'https://auth.recruitee.com/?intercom_open=true',
        label: 'Contact us',
        target: '_blank',
      },
      order_summary: 'Order summary:',
      products: [
        {
          title: 'APEC',
        },
        {
          title: 'Vlaamse Dienst voor Arbeidsbemiddeling en Beroepsopleiding (VDAB)',
        },
        {
          title: 'Stepstone | Germany',
        },
      ],
      primary_cta: {
        href: 'https://tellent.com',
        label: 'View details',
      },
    },
  ];
